import {
  AreaChart,
  Area,
  CartesianGrid,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import React, { useState } from "react";
import { Modal } from "../modal";
import graphsService from "./graph-service";
import { Toggle } from "../toggle";
import { numberFormatted } from "../utils/graph.util";

export function AreaHoursChart(props) {
  const [show_modal, setShowModal] = useState(false);
  const [time_frame, setTimeFrame] = useState("weeks");
  const [graphs_by_time_frame, setGraphsByTimeFrame] = useState({});

  const openModal = async () => {
    setShowModal(true);

    await fetchInnerGraphsData(time_frame);
  };

  const timeFrameChange = async (value) => {
    if (value) {
      setTimeFrame("weeks");
      await fetchInnerGraphsData("weeks");
    } else {
      setTimeFrame("days");
      await fetchInnerGraphsData("days");
    }

    return value;
  };

  const fetchInnerGraphsData = async (time_frame) => {
    const results = await graphsService.fetchLastHoursKpiByTimeFrame(
      props.data_key,
      time_frame
    );
    setGraphsByTimeFrame(results);
  };

  return (
    <>
      {props.data_key !== "only_hour" &&
        props.data_key !== "full_hour" &&
        props.data_key !== "our_time_zone" && (
          <div className="m-auto hover:bg-slate-400">
            {/*<LineChart*/}
            {/*  width={300}*/}
            {/*  height={150}*/}
            {/*  data={props.entities}*/}
            {/*>*/}
            {/*  <CartesianGrid strokeDasharray="1 1"/>*/}
            {/*  <XAxis tick={{fill:"#fff"}} dataKey="day"/>*/}
            {/*  <YAxis tick={{fill:"#fff"}}/>*/}
            {/*  <Tooltip contentStyle={{backgroundColor: "#8884d8", color: "#fff"}} itemStyle={{color: "#fff"}}*/}
            {/*           formatter={(value: number) => new Intl.NumberFormat('en').format(value)}/>*/}
            {/*  <Line type="monotone" dataKey={props.data_key} stroke="#fff" fill="#82ca9d"/>*/}
            {/*  <Legend verticalAlign="top" height={36}/>*/}
            {/*</LineChart>*/}

            <AreaChart
              onClick={() => openModal()}
              width={300}
              height={150}
              data={props.entities}
            >
              <CartesianGrid strokeDasharray="1 1" />
              <XAxis tick={{ fill: "#fff" }} dataKey={props.label} />
              <YAxis
                tick={{ fill: "#fff" }}
                tickFormatter={numberFormatted()}
              />
              <Tooltip
                contentStyle={{ backgroundColor: "#8884d8", color: "#fff" }}
                itemStyle={{ color: "#fff" }}
                formatter={(value) => new Intl.NumberFormat("en").format(value)}
              />
              <Area
                type="monotone"
                dataKey={props.data_key}
                stroke="#fff"
                fill="#82ca9d"
              />
              <Legend verticalAlign="top" height={36} iconType="wye" />
            </AreaChart>

            <Modal show={show_modal} handleClose={() => setShowModal(false)}>
              <Toggle label={time_frame} callback={timeFrameChange} />
              <h3 className="text-2xl mt-4 mb-4 ml-1">
                {props.data_key} - {time_frame.toUpperCase()} Comparison
              </h3>
              <div className="flex flex-row">
                {Object.keys(graphs_by_time_frame).length > 0 &&
                  Object.keys(graphs_by_time_frame).map((day) => (
                    // <ResponsiveContainer width={500}
                    //                      height={300}>
                    <AreaChart
                      width={500}
                      height={300}
                      data={graphs_by_time_frame[day]}
                      syncId="anyId"
                    >
                      <CartesianGrid strokeDasharray="1 1" />
                      <XAxis dataKey="full_hour" />
                      <YAxis />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "#8884d8",
                          color: "#fff",
                        }}
                        itemStyle={{ color: "#fff" }}
                        formatter={(value) =>
                          new Intl.NumberFormat("en").format(value)
                        }
                      />
                      <Area type="monotone" dataKey="sum" fill="#82ca9d" />
                      <Legend
                        content={(props) => (
                          <span className="text-lg">{day}</span>
                        )}
                        verticalAlign="top"
                        height={60}
                        iconType="wye"
                      />
                    </AreaChart>
                    // </ResponsiveContainer>
                  ))}
              </div>
            </Modal>

            {/*<BarChart*/}
            {/*  width={300}*/}
            {/*  height={150}*/}
            {/*  data={props.entities}*/}
            {/*>*/}
            {/*  <CartesianGrid strokeDasharray="1 1"/>*/}
            {/*  <XAxis dataKey={props.label} tick={{fill: "#fff"}}/>*/}
            {/*  <YAxis tick={{fill: "#fff"}}/>*/}
            {/*  <Tooltip contentStyle={{backgroundColor: "#8884d8", color: "#fff"}} itemStyle={{color: "#fff"}}*/}
            {/*           formatter={(value: number) => new Intl.NumberFormat('en').format(value)}/>*/}
            {/*  <Legend verticalAlign="top" height={36} color='#fff'/>*/}
            {/*  <Bar dataKey={props.data_key} fill="#82ca9d"/>*/}
            {/*</BarChart>*/}
          </div>
        )}
    </>
  );
}
